module.exports = __webpack_public_path__ + "static/media/home-image.6aa66be1.webp";